"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jfl_1 = require("./jfl");
function validate(jfd, jfl) {
    let result = [];
    jfl.groups.forEach((group, groupIdx) => {
        switch (group.type) {
            case 'singleFields':
                result = result.concat(validateSingleFieldsGroup(jfd, group, groupIdx));
                break;
            case 'fieldArray':
                result = result.concat(validateFieldArrayGroup(jfd, group, groupIdx));
                break;
            case 'explicitMultipleOccurrence':
            case 'explicitMultipleOccurrenceItem':
                result = result.concat(validateExplicitMultipleOccurrenceGroup(jfd, group, groupIdx));
                break;
        }
    });
    return result;
}
exports.default = validate;
function validateSingleFieldsGroup(jfd, group, groupIdx) {
    const result = [];
    jfl_1.getAllFieldNames(group).forEach((fieldDesc) => {
        const [fieldName] = fieldDesc.name.split('.');
        const fieldDef = jfd.getFieldDef(fieldDesc.name);
        // check that we don't include fields with multiple occurrences
        // case 1: MONS
        // these are defined in the JFL as { field: "MONS" }
        if (fieldDef.hasMultipleOccurrences()) {
            result.push({
                location: `${fieldDef.name} (groups.${groupIdx}.fields.${fieldDesc.index})`,
                message: 'Has multiple occurrences'
            });
        }
        // case 2: MOS
        // these are defined in the JFL as { field: "MOS.subfield" }
        if (fieldName !== fieldDesc.name) {
            const parentFieldDef = jfd.getFieldDef(fieldName);
            if (parentFieldDef.hasMultipleOccurrences()) {
                result.push({
                    location: `${parentFieldDef.name} (groups.${groupIdx}.fields.${fieldDesc.index})`,
                    message: 'Has multiple occurrences'
                });
            }
        }
        // check that we don't include a field with subfields
        if (fieldDef.hasSubFields()) {
            result.push({
                location: `${fieldDef.name} (groups.${groupIdx}.fields.${fieldDesc.index})`,
                message: 'Has subfields'
            });
        }
    });
    return result;
}
function validateFieldArrayGroup(jfd, group, groupIdx) {
    const result = [];
    // check that we have a single field
    if (group.fields.length > 1) {
        result.push({
            location: `${group.label} (groups.${groupIdx})`,
            message: 'Has multiple fields'
        });
    }
    group.fields.forEach((jflField, fieldIdx) => {
        if (jfl_1.isFieldGroup(jflField)) {
            result.push({
                location: `groups.${groupIdx}.fields.${fieldIdx}`,
                message: 'Has multiple fields'
            });
            return;
        }
        const [fieldName, subfieldName] = jflField.field.split('.');
        const fieldDef = jfd.getFieldDef(fieldName);
        // check that we don't include fields with a single occurrence
        if (!fieldDef.hasMultipleOccurrences()) {
            result.push({
                location: `${fieldDef.name} (groups.${groupIdx}.fields.${fieldIdx})`,
                message: 'Has single occurrence'
            });
        }
        // check that we don't include specific subfields
        if (subfieldName) {
            result.push({
                location: `${fieldDef.name} (groups.${groupIdx}.fields.${fieldIdx})`,
                message: 'Subfield defined'
            });
        }
    });
    return result;
}
function validateExplicitMultipleOccurrenceGroup(jfd, group, groupIdx) {
    const result = [];
    jfl_1.getAllFieldNames(group).forEach((fieldDesc) => {
        const [fieldName] = fieldDesc.name.split('.');
        const fieldDef = jfd.getFieldDef(fieldName);
        // check that we don't include fields with a single occurrence
        if (!fieldDef.hasMultipleOccurrences()) {
            result.push({
                location: `${fieldDef.name} (groups.${groupIdx}.fields.${fieldDesc.index})`,
                message: 'Has single occurrence'
            });
        }
    });
    // check that all fields have the same min/max occurrences
    const allFields = jfl_1.getAllFieldNames(group).map((fieldDesc) => fieldDesc.name);
    for (let i = 0; i < allFields.length; i++) {
        for (let j = i; j < allFields.length; j++) {
            const fieldDef1 = jfd.getFieldDef(allFields[i].split('.')[0]);
            const fieldDef2 = jfd.getFieldDef(allFields[j].split('.')[0]);
            if (fieldDef1.minOccurrences !== fieldDef2.minOccurrences ||
                fieldDef1.maxOccurrences !== fieldDef2.maxOccurrences) {
                result.push({
                    location: `${fieldDef1.name} (groups.${groupIdx}.fields.${i}), ` +
                        `${fieldDef2.name} (groups.${groupIdx}.fields.${j})`,
                    message: 'Min/max occurrence mismatch'
                });
            }
        }
    }
    return result;
}
//# sourceMappingURL=jfl-validator.js.map